import { RotatingLines } from "react-loader-spinner";
import React, { ReactNode, useEffect, useState } from "react";
import { setToggleData } from "./store/reducers/toggleReduce";
import { asRegisterCheck, asRegisterInit } from "./utils/rtkQueryBaseQueryUtil";
import { addRegisterIng, addReportRegisterIng } from "./store/reducers/asReduce";
import { useDispatch } from "react-redux";
import { useAppSelector } from "./store/actions/action";
import styled from "styled-components";
import IconInfo from "./assets/images/iconInfo.svg";

type P = {
  children: ReactNode;
};

const Layout = ({ children }: P) => {
  const dispatch = useDispatch();
  const delay = (ms: any) => new Promise((resolve) => setTimeout(resolve, ms));
  // as 등록 async
  const addRegisterIngReducer = useAppSelector((state) => state.asReduce.ingAsRegister);
  const [registerText, setRegisterText] = useState<string>();
  const [registerStart, setRegisterStart] = useState(addRegisterIngReducer);
  const [registerEnd, setRegisterEnd] = useState(false);

  // 완료보고 등록 async
  const addReportRegisterIngReducer = useAppSelector((state) => state.asReduce.ingReportRegister);
  const [reportRegisterText, setReportRegisterText] = useState<string>();
  const [reportRegisterStart, setReportRegisterStart] = useState(addReportRegisterIngReducer);
  const [reportRegisterEnd, setReportRegisterEnd] = useState(false);
  const toggleData = useAppSelector((state) => state.toogleReduce);
  const [sendMode, setSendMode] = useState("");

  useEffect(() => {
    switch (toggleData.mode) {
      case "SENDING":
        setSendMode(toggleData.data);
        break;
      case "SUCCESS":
        setSendMode(toggleData.data);
        delay(1000).then(() => dispatch(setToggleData({ mode: "IDLE", data: "" })));
        break;
      case "ERROR":
        setSendMode(toggleData.data);
        delay(3000).then(() => dispatch(setToggleData({ mode: "IDLE", data: "" })));
        break;
      case "IDLE":
      default:
        setSendMode("");
        break;
    }
  }, [toggleData.mode]);
  // AS 등록중 뒤로가기를 했을때 toast 메세지 띄워주는 로직
  // as 등록 hook
  useEffect(() => {
    if (addRegisterIngReducer) {
      setRegisterText("AS 등록 중입니다.");
      setRegisterStart(true);
      const timer = setInterval(() => {
        const check = asRegisterCheck();
        setRegisterEnd(check);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [addRegisterIngReducer]);

  useEffect(() => {
    if (registerEnd) {
      setRegisterText("AS 등록 완료");
      asRegisterInit();
      dispatch(addRegisterIng(false));
      const timer = setTimeout(() => {
        setRegisterStart(false);
        setRegisterEnd(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [registerEnd]);

  // 완료보고 등록 hook
  useEffect(() => {
    if (addReportRegisterIngReducer) {
      setReportRegisterText("완료보고 등록 중입니다.");
      setReportRegisterStart(true);
      const timer = setInterval(() => {
        const check = asRegisterCheck();
        setReportRegisterEnd(check);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [addReportRegisterIngReducer]);

  useEffect(() => {
    if (reportRegisterEnd) {
      setReportRegisterText("완료보고 등록 완료");
      asRegisterInit();
      dispatch(addReportRegisterIng(false));
      const timer = setTimeout(() => {
        setReportRegisterStart(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [reportRegisterEnd]);
  return (
    <>
      {registerStart ? (
        <ToastMessage>
          <p className={"info"}>{registerText}</p>
        </ToastMessage>
      ) : (
        ""
      )}
      {reportRegisterStart ? (
        <ToastMessage>
          <p className={"info"}>{reportRegisterText}</p>
        </ToastMessage>
      ) : (
        ""
      )}
      {sendMode && (
        <ToastMessage>
          <p className={toggleData.mode == "SENDING" ? "toggle" : "info"}>{sendMode}</p>
          {toggleData.mode == "SENDING" && <RotatingLines width="20" strokeColor="#ffffff" strokeWidth="5" />}
        </ToastMessage>
      )}
      {children}
    </>
  );
};
export default Layout;

const ToastMessage = styled.div`
  // display: none;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  min-height: 50px;
  padding: 15px;
  padding-top: calc(${({ theme }) => theme.mobile.notchHeight}px + 15px);
  background: rgba(0, 38, 62, 0.95);
  box-shadow: 0 0 5px ${({ theme }) => theme.color.main};
  .info {
    padding-left: 26px;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    background: url(${IconInfo}) no-repeat -3px -2px;
    ${({ theme }) => theme.textOverflow.multiLine(2)}
  }
  .toggle {
    padding-left: 26px;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    ${({ theme }) => theme.textOverflow.multiLine(2)}
  }
  > svg {
    position: absolute;
    top: calc(${({ theme }) => theme.mobile.notchHeight}px + 15px);
    left: 15px;
  }
`;
